import React from "react";
import { Link } from "react-router-dom";
import AdminlogoImg from "images/logo-new.svg";
import logoLightImg from "images/logo-light.svg";

export interface AdminLogoProps {
  img?: string;
  imgLight?: string;
  className?: string;
}

const AdminLogo: React.FC<AdminLogoProps> = ({
  img = AdminlogoImg,
  imgLight = logoLightImg,
  className = "flex-shrink-0",
}) => {
  return (
    <Link
      to="/admin/dashboard"
      className={`ttnc-logo inline-block text-slate-600 ${className}`}
    >
      {/* THIS USE FOR MY CLIENT */}
      {/* PLEASE UN COMMENT BELLOW CODE AND USE IT */}
      {img ? (
        <img
          className={`block max-h-8 sm:max-h-10 xl:max-h-16 ${
            imgLight ? "dark:hidden" : ""
          }`}
          src={img}
          alt="Logo"
        />
      ) : (
        "Logo Here"
      )}
      {imgLight && (
        <img
          className="hidden max-h-8 sm:max-h-10 xl:max-h-16 dark:block"
          src={imgLight}
          alt="Logo-Light"
        />
      )}
    </Link>
  );
};

export default AdminLogo;
